module.exports = __webpack_public_path__ + "img/logo1.1250d83c.png";